import type { ProductCard, ProductDetails } from "@/lib/centra/formatters";
import type { BaseSelectionItem } from "@frend-digital/centra-types/selection";
import type { GA4Product } from "@frend-digital/events/gtm";

export const selectionItemToGTAGProduct = (
  item: BaseSelectionItem,
  currency: string,
) => {
  const categories = item.product?.categoryName
    ? Object.fromEntries(
        item.product?.categoryName
          .map((name, i) => {
            return [`item_category${i === 0 ? "" : i + 1}`, name];
          })
          .filter(Boolean)
          .slice(0, 4),
      )
    : {};

  return {
    quantity: item.quantity ?? 1,
    item_id: item.product?.sku ?? "",
    item_name: item.product?.name ?? "",
    price: Math.floor(item.priceEachAsNumber ?? 0),
    ...categories,
    currency,
    discount: Math.ceil(
      (item?.priceEachBeforeDiscountAsNumber ?? 0) -
        (item.priceEachAsNumber ?? 0),
    ),
    item_variant: item.product?.variantName ?? "",
    centra_product: item.product?.centraProduct,
    centra_variant: item.product?.centraVariant,
    centra_size: item.product?.items?.at(0)?.sizeId || "",
  };
};

export const productDetailsToGTAGProduct = (
  product: ProductDetails,
  currency: string,
): GA4Product => {
  const categories = product.breadcrumbs
    ? Object.fromEntries(
        product.breadcrumbs
          .map(({ name }, i) => {
            if (name === product.name) return null;

            return [`item_category${i === 0 ? "" : i + 1}`, name];
          })
          .filter(Boolean)
          .slice(0, 4),
      )
    : {};

  return {
    quantity: 1,
    item_id: product.sku!,
    item_name: product.name,
    price: Math.floor(product?.priceAsNumber ?? 0),
    ...categories,
    currency,
    discount: Math.ceil(
      (product?.priceBeforeDiscountAsNumber ?? 0) -
        (product?.priceAsNumber ?? 0),
    ),
    item_variant: product.variantName,
    centra_variant: product.centraVariant,
    centra_product: product.centraProduct,
    centra_size: product?.items?.at(0)?.sizeId || "",
  };
};

export const productCardsToGTAGProducts = ({
  categoryPage,
  currency,
  products,
}: {
  products: ProductCard[];
  currency: string;
  categoryPage: string;
}) => {
  return products.map((product, index) => {
    const categories = product.breadcrumbs
      ? Object.fromEntries(
          product.breadcrumbs
            .map(({ name }, i) => {
              if (name === product.name) return null;

              return [`item_category${i === 0 ? "" : i + 1}`, name];
            })
            .filter(Boolean)
            .slice(0, 4),
        )
      : {};

    return {
      item_id: product.sku!,
      item_name: product.name,
      price: Math.floor(product?.priceAsNumber ?? 0),
      affiliation: "Website",
      currency,
      discount: Math.ceil(
        (product?.priceBeforeDiscountAsNumber ?? 0) -
          (product?.priceAsNumber ?? 0),
      ),
      item_brand: "Alfa",
      ...categories,
      index,
      item_variant: product.variantName,
      item_list_name: categoryPage,
      centra_variant: product.centraVariant,
      centra_product: product.centraProduct,
      centra_size: product?.items?.at(0)?.sizeId || "",
    };
  });
};
